import { AUTHENTICATION } from '../constants';

export const login = payload => dispatch => {
  dispatch({ type: AUTHENTICATION, payload });
}

export const logout = () => dispatch => {
  dispatch({ type: AUTHENTICATION, payload: {id: '', type: '', token: ''} });
}
